import React from "react";
import { GLOBAL_IMAGES } from "../../assets/asset";
import { Link, useNavigate } from "react-router-dom";

const SettingsHeader = ({ name = "Settings", oneBack="false" }) => {
  const navigate = useNavigate();
  return (
    <header className="relative w-full flex items-center px-20 pt-3">
      {/* Left side (logo + back) */}
      <div className="flex items-center gap-14">
        <Link to={"/"}>
          <img src={GLOBAL_IMAGES.dingo} className="h-20 w-auto" alt="" />
        </Link>
        <img
          src={GLOBAL_IMAGES.LoginBackButton}
          className="size-14 cursor-pointer"
          alt="Back"
          onClick={oneBack ?() => navigate(-1):() => navigate("/yearsdashboard", { replace: true })}
        />
      </div>

      {/* Center title */}
      <h1 className="absolute left-1/2 transform -translate-x-1/2 text-4xl font-mulish font-bold">
        {name}
      </h1>
    </header>
  );
};

export default SettingsHeader;
